<template>
  <!--<v-app  :class="{'activity_content': $route.meta.showInActivityNavigation || $route.meta.contentBuilder}">-->
  <v-app>
    <LockPlatformPaymentFailed v-if="!loading" />
    <LockPlatform v-if="!loading" />
    <LockPlatformNotAcceptedTerms v-if="!loading"/>
    <Navbar v-if="$route.meta.showMenuNavigation && !loading" />
    <NavbarTopActivity
      v-if="
        $route.meta.showActivityNavigation &&
        !loading
      "
    />
    <NavbarTopWorkflow
      v-if="
        $route.meta.showWorkflowNavigation &&
        !loading
      "
    />
    <NavbarTopActivityPageEdit
      v-if="$route.meta.showActivityPageEditNavigation && !loading"
    />
    <NavbarTopActivityQuizEdit
      v-if="$route.meta.showActivityQuizEditNavigation && !loading"
    />
    <NavbarTopActivityScormEdit
      v-if="$route.meta.showActivityScormEditNavigation && !loading"
    />
    <NavbarTopActivityChecklistEdit
      v-if="$route.meta.showActivityChecklistEditNavigation && !loading"
    />
    <NavbarTopActivitySurveyEdit
      v-if="$route.meta.showActivitySurveyEditNavigation && !loading"
    />
    <NavbarInActivity
      v-if="
        $route.meta.showInActivityNavigation &&
        !loading &&
        (isAuth || (!isAuth && !$route.meta.requiresAuth))
      "
    />
    <NavbarTop v-if="$route.meta.showTopNavigation && !loading" />
    <NavbarTopHub v-if="$route.meta.showHubNavigation && !loading" />
    <NavbarTopCategory v-if="$route.meta.showCategoryNavigation && !loading" />
    <v-main
      :class="{
        'greyactivitybackground':
          $route.name == 'ViewActivityQuiz' ||
          $route.name == 'ViewActivityPage' ||
          $route.name == 'ViewActivityScorm' ||
          $route.name == 'ViewActivityChecklist' ||
          $route.name == 'ViewActivitySurvey',
        'pt-16':
          ($route.meta.showTopNavigation ||
            $route.meta.showActivityNavigation ||
            $route.meta.showHubNavigation ||
            $route.meta.showCategoryNavigation ||
            $route.meta.showActivityPageEditNavigation ||
            $route.meta.showActivityQuizEditNavigation ||
            $route.meta.showActivityScormEditNavigation ||
            $route.meta.showActivityChecklistEditNavigation ||
            $route.meta.showActivitySurveyEditNavigation ) &&
          !mobile(),
        'pt-14':
          ($route.meta.showTopNavigation ||
            $route.meta.showActivityNavigation ||
            $route.meta.showHubNavigation ||
            $route.meta.showCategoryNavigation) &&
          mobile(),
      }"
    >
      <v-container
        fluid
        style="height: 100%"
        :class="{
          'pa-0':
            $route.name == 'Login' ||
            $route.name == 'CustomLogin' ||
            $route.name == 'ViewHub' ||
            $route.name == 'ViewCategory' ||
            $route.name == 'ViewActivityPage' ||
            $route.name == 'ViewActivityScorm' ||
            $route.name == 'ViewActivityQuiz' ||
            $route.name == 'ViewActivityChecklist' ||
            $route.name == 'ViewActivitySurvey' ||
            $route.name == 'EditActivityPage' ||
            $route.name == 'EditActivityScorm' ||
            $route.name == 'EditActivityChecklist' ||
            $route.name == 'EditActivitySurvey' ||
            $route.name == 'EditWorkflow' ||
            $route.name == 'RegistrationGettingStarted',
          'pb-12':
            $route.name != 'EditWorkflow' &&
            $route.name != 'EditActivityPage' &&
            $route.name != 'ViewActivityPage' &&
            $route.name != 'ViewActivityScorm' &&
            $route.name != 'ViewActivityQuiz' &&
            $route.name != 'ViewActivityChecklist' &&
            $route.name != 'ViewActivitySurvey' &&
            $route.name != 'EditActivityScorm' &&
            $route.name != 'EditActivitySurvey' &&
            $route.name != 'Login' &&
            $route.name != 'CustomLogin' &&
            $route.name != 'EditActivityChecklist' &&
            $route.name != 'RegistrationGettingStarted',
        }"
      >
        <!--<router-view v-if="!loading" class="fill-height" />-->
        <!--  $route.fullPath added as key - 
              problem when load different content with same url (just content id different) - activity pages, quizzes, scroms etc...
              ex. click  acitivty/{activity_id}}/page/{id} ... click on another page new content is not loaded
            -->
        <router-view v-if="!loading" class="fill-height" :key="$route.meta.overrideRouteKey ? '' : $route.fullPath"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import NavbarTopActivity from "./components/NavbarTopActivity";
import NavbarTopWorkflow from "./components/NavbarTopWorkflow";
import NavbarTopActivityPageEdit from "./components/NavbarTopActivityPageEdit";
import NavbarTopActivityQuizEdit from "./components/NavbarTopActivityQuizEdit";
import NavbarTopActivityScormEdit from "./components/NavbarTopActivityScormEdit";
import NavbarTopActivityChecklistEdit from "./components/NavbarTopActivityChecklistEdit";
import NavbarTopActivitySurveyEdit from "./components/NavbarTopActivitySurveyEdit";
import NavbarInActivity from "./components/NavbarInActivity";
import NavbarTop from "./components/NavbarTop";
import NavbarTopHub from "./components/NavbarTopHub";
import NavbarTopCategory from "./components/NavbarTopCategory";
import { getSpaceByURLWithoutToken, getSpaceByURL } from "./api/spaceApi";
import { repeatedMethodsMixin } from "./mixins/repeatedMethodsMixin";
import { getActivity,getActivityEditors } from "./api/activityApi";
import { getUser } from "./api/userApi";
import i18n from "./plugins/i18n";
import LockPlatform from "./components/LockPlatform";
import LockPlatformPaymentFailed from './components/LockPlatformPaymentFailed';
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import LockPlatformNotAcceptedTerms from "./components/LockPlatformNotAcceptedTerms.vue";

export default {
  name: "App",

  components: {
    Navbar,
    NavbarTopActivity,
    NavbarTopWorkflow,
    NavbarInActivity,
    NavbarTop,
    NavbarTopHub,
    NavbarTopCategory,
    NavbarTopActivityPageEdit,
    NavbarTopActivityQuizEdit,
    NavbarTopActivityScormEdit,
    NavbarTopActivityChecklistEdit,
    NavbarTopActivitySurveyEdit,
    LockPlatform,
    LockPlatformPaymentFailed,
    LockPlatformNotAcceptedTerms
},
  mixins: [repeatedMethodsMixin],

  data() {
    return {
      loading: false,
      isAuth: window.$cookies.get("token") ? true : false,
      locked: false
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.clearStorageData);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.clearStorageData);
  },
  async created() {
    var space = window.location.host.split(".")[0];
    this.loading = true;
    //get user data
    if (window.$cookies.get("id")) {
      try {
        const response = await getUser(window.$cookies.get("id"));
        if (response.status == 200) {
          localStorage.user = JSON.stringify(response.data.data.attributes);
          if (localStorage.user) {
            let language = localStorage.user
              ? JSON.parse(localStorage.user).language
              : "sv";
            if (language) {
              i18n.locale = language.trim();
              window.$cookies.set(
                "language",
                i18n.locale,
                0,
                null,
                process.env.VUE_APP_DOMAIN
              );
            }
          }
        }
      } catch (e) {
        // TODO:
      }
    }else{
      window.$cookies.remove("language", null, process.env.VUE_APP_DOMAIN);
 
      if (localStorage.space) {
          let spaceData = JSON.parse(localStorage.space);

          if(window.$cookies.get("language") != spaceData.language){ 
            i18n.locale = spaceData.language.trim();
            window.$cookies.set(
              "language",
              i18n.locale,
              0,
              null,
              process.env.VUE_APP_DOMAIN
            );
          }
         
        }
      
    }

    if (!this.$route.meta.requiresAuth) {
      if (space != "id") {
        try {
          const response = await getSpaceByURLWithoutToken(space);
          if (response.status) {
            if (response.status == 200) {
              this.proceedSpaceData(response);
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 404) {
              this.$router.push("/not-exist");
            }
          }
        }
        //}
      }
    } else {
      if (space != "id") {
        try {
          const response = await getSpaceByURL(space);
          if (response.status) {
            if (response.status == 200) {
              this.proceedSpaceData(response);
              if(this.$store.state.lockPaymentFailed == true){
                  this.$store.dispatch("unlockPlatform");
              }
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              this.$router.push("/forbidden");
            }
            if (e.response.status == 404) {
              this.$router.push("/not-exist");
            }
          }
        }
      }
    }

    if (space == "id") {
      this.removeSpaceData();
    }

    //PREVENT EDITING
    if (
      new URL(window.location.href).searchParams &&
      new URL(window.location.href).searchParams.get("redirect")
    ) {
      if (
        new URL(window.location.href).searchParams
          .get("redirect")
          .split("/")[1] == "activity" &&
        new URL(window.location.href).searchParams
          .get("redirect")
          .split("/")[5] == "edit"
      ) {
        var activityId = new URL(window.location.href).searchParams.get("redirect").split('/')[2]
        var itemId = new URL(window.location.href).searchParams.get("redirect").split('/')[4]
        var itemType = new URL(window.location.href).searchParams.get("redirect").split('/')[3]
        const response = await getActivityEditors(activityId)
        if(response.data.data.find(page => page.attributes.entity_id == itemId)){
            if(itemType == 'page'){
                this.$router.push({name: 'ViewActivityPage', params: {id: activityId, pageId: itemId, preventEditing: true}})
            }else if(itemType == 'quiz'){
                this.$router.push({name: 'ViewActivityQuiz', params: {id: activityId, quizId: itemId, preventEditing: true}})
            }else if(itemType == 'scorm') {
                this.$router.push({name: 'ViewActivityScorm', params: {id: activityId, scormId: itemId, preventEditing: true}})
            }else if(itemType == 'checklist') {
                this.$router.push({name: 'ViewActivityChecklist', params: {id: activityId, checklistId: itemId, preventEditing: true}})
            }else{
                this.$router.push({name: 'ViewActivitySurvey', params: {id: activityId, surveyId: itemId, preventEditing: true}})
            }
        }
      }
    }
    //CHECK ACTIVITY SHARING SETTING
    //changed this.$route.fullPath -> window.location.pathname, problems when using back button
    if (
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/").length == 3) ||
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/")[3] == "page" &&
        window.location.pathname.split("/").length == 5) ||
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/")[3] == "quiz" &&
        window.location.pathname.split("/").length == 5) ||
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/")[3] == "checklist" &&
        window.location.pathname.split("/").length == 5) ||
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/")[3] == "scorm" &&
        window.location.pathname.split("/").length == 5) ||
      (window.location.pathname.split("/")[1] == "activity" &&
        window.location.pathname.split("/")[3] == "survey" &&
        window.location.pathname.split("/").length == 5)
    ) {
      if(!this.locked){
        try {
          const activityResponse = await getActivity(
            window.location.pathname.split("/")[2]
          );
          if (activityResponse.status) {
            if (activityResponse.status == 200) {
              if(activityResponse.data.data.attributes.is_template && activityResponse.data.data.attributes.is_template == true){
                this.$router.push({name: 'PageAccessDenied'})
              }
              let sharingSetting =
                activityResponse.data.data.attributes.sharing_setting;
              if (sharingSetting != "Open") {
                this.$route.meta.requiresAuth = true;
              }
            } else {
              this.$route.meta.requiresAuth = true;
            }
          }
        } catch (e) {
          this.$route.meta.requiresAuth = true;
        }
      }
    }

    polyfillCountryFlagEmojis();

    this.loading = false;
  },
  methods: {
    goBack() {
      this.$router.push({ path: this.$router.back() });
    },
    proceedSpaceData(response) {
      window.$cookies.set("space_id", response.data.data.id, 0, null);
      window.$cookies.set("space_language", response.data.data.attributes.language, 0, null);
      localStorage.space = JSON.stringify(response.data.data.attributes);

      this.locked = response.data.data.attributes.locked
      if(this.isAuth){
      //it can be defined previously in routes file (for some routes)
        if(!this.$store.state.productPlan.id){
          this.$store.dispatch("getSubscribedPlan", response.data.data);
        }
      }

      this.$store.dispatch("setBrokenWorkflow", JSON.parse(localStorage.space).workflow_warning)
      

      //change title
      document.title = "Skillboost - " + response.data.data.attributes.name;
    },
    removeSpaceData() {
      if (window.$cookies.isKey("space_id")) {
        window.$cookies.remove("space_id");
      }
      if (localStorage.space) {
        localStorage.removeItem("space");
      }
    },
    clearStorageData() {
      localStorage.removeItem("space");
    },
  },
};
</script>
<style>
.v-messages {
  padding: 0 8px;
}
.v-application .v-footer--fixed.white {
  border-top: 1px solid #dddddd !important;
}
.white-background {
  background-color: #ffffff;
}
.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-bottom: 8px;
}
.v-text-field.v-input--is-focused .v-input__slot {
  border: 1px solid var(--v-inputfocusblue-base) !important;
}
.theme--light.v-input input,
.theme--light.v-input textarea {
  color: var(--v-greytext-base) !important;
}
.theme--light.v-input textarea  {
 margin: 18px 5px 18px 0px !important; 
}

.theme--light.v-input textarea[disabled] {
  color: var(--v-greytext-base) !important;
  -webkit-text-fill-color:  var(--v-greytext-base) !important;
  opacity: 1;
}

.saml .theme--light.v-input input,
.saml .theme--light.v-input textarea {
  color: var(--v-darktext-base) !important;
}

.saml .theme--light.v-input--is-disabled input,
.saml .theme--light.v-input--is-disabled textarea {
  color: var(--v-greytext-base) !important;
}

.show-google .v-input__slot {
  margin-bottom: 0 !important;
}

.set-rule .v-text-field.v-input--is-focused .v-input__slot {
  border: none !important;
}

.set-date-filter.v-text-field.v-input--is-focused .v-input__slot {
  border: none !important;
}

.set-date-filter.v-text-field .v-text-field__slot {
  font-size: 12px !important;
}

/*combobox input */
/*.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  padding: 8px !important;
}*/
/*links cards my-spaces*/
.v-card--link:focus:before {
  border-radius: inherit;
}
.v-card > *:first-child:not(.v-btn):not(.v-chip),
.v-card > *:last-child:not(.v-btn):not(.v-chip) {
  border-radius: inherit;
}

/*to fix autocomplete in Chrome, no solution for now for v-text-field
/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

/*Change text in autofill textbox*/
input:-webkit-autofill {
  -webkit-text-fill-color: #7c8386 !important;
}
/*outlined border color with opacity*/
.v-btn--outlined {
  border-color: rgb(38 50 56 / 20%);
}

/*navmenu bg color remove*/
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover
  span.title,
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover
  .v-list-item__icon,
.theme--light.v-list-item:hover .section-icon::before {
  color: var(--v-anchor-base) !important;
}

.navbar-left-global .theme--light.v-list-item.v-list-item--active {
  font-weight: 500;
}
.navbar-left-global
  .theme--light.v-list-item.v-list-item--active:not(.v-list-item--disabled) {
  color: var(--v-anchor-base) !important;
}
.navbar-left-global .theme--light.v-list-item.v-list-item--active:hover::before,
.navbar-left-global .theme--light.v-list-item.v-list-item--active::before {
  opacity: 0;
}

/*navmenu activity bg color remove*/
.navbar-left-activity .theme--light.v-list-item.v-list-item--active {
  font-weight: 500;
}
.navbar-left-activity
  .theme--light.v-list-item.v-list-item--active.activity-page-item:not(.v-list-item--disabled),
.navbar-left-activity
  .theme--light.v-list-item.v-list-item--active.activity-page-item:not(.v-list-item--disabled)
  .success--text,
.navbar-left-activity
  .theme--light.v-list-item.v-list-item--active.activity-page-item:not(.v-list-item--disabled)
  .warning--text {
  color: var(--v-anchor-base) !important;
}
.navbar-left-activity
  .theme--light.v-list-item.v-list-item--active:hover::before,
.navbar-left-activity .theme--light.v-list-item.v-list-item--active::before {
  opacity: 0;
}

/*Custom Tab Menu */
.custom-tab-menu .v-list-item.theme--light {
  float: left;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled).accent--text {
  color: var(--v-accent-base) !important;
  caret-color: var(--v-accent-base) !important;
  font-weight: 500;
}

/***DisplayPipe after the Custom Tabs */
.custom-tab-menu .v-list-item::after {
  content: "|";
  font-size: 20px;
  display: block;
  position: relative;
  right: -15px;
  top: 7px;
  color: #ddd;
  cursor: default;
  margin: 0 10px;
}
.custom-tab-menu .v-list-item:first-child {
  padding-left: 0;
}
.custom-tab-menu .v-list-item:last-child {
  padding-right: 40px;
}
.custom-tab-menu .v-list-item:last-child::after {
  content: "";
  font-size: 0;
  margin: 0;
}
.custom-tab-menu .v-ripple__container {
  left: -10px;
  width: 96%;
}

.custom-tab-menu p::after {
  content: "|";
  font-size: 20px;
  position: relative;
  right: -15px;
  color: #ddd;
  cursor: default;
  margin: 0;
}

.center-button-on-image {
  position: absolute;
  bottom: 25px;
  width: 100%;
  text-align: center;
}

/** Fixing word break issue in title */
.no-break {
  word-break: break-word;
}

.custom-center {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.activity-page-height {
  /*height: calc(100vh - 88px) !important;*/
  overflow-y: auto;
}

.dragArea {
  height: 100%;
}

.dragAreaQuiz {
  min-width: 600px;
}

.dragAreaEmptyQuiz {
  max-width: 960px;
}

.dragAreEmptyChecklist {
  height: 150px;
}

.page-block, .question-block {
  margin: 20px auto;
  text-align: center;
  border-radius: 24px !important;
}

.ghost {
  border: 2px dashed var(--v-accent-base);
  height: 100px;
  overflow-y: hidden;
  border-radius: 5px;
}
.grid-ghost {
  border: 2px dashed var(--v-accent-base);
  overflow-y: hidden;
  border-radius: 5px;
}
.list-ghost {
  border: 2px dashed var(--v-accent-base);
  overflow-y: hidden;
  border-radius: 5px;
}
.ghost-first {
  border: 2px dashed var(--v-accent-base);
  height: 48px;
  overflow-y: hidden;
  border-radius: 5px;
}
.ghost-sub {
  border: 2px dashed var(--v-accent-base);
  height: 48px;
  overflow-y: hidden;
  border-radius: 5px;
}
.ghost-block {
  border: 2px dashed var(--v-accent-base) !important;
  height: 100px;
  overflow-y: hidden;
  border-radius: 0 !important;
}
.ghost-block-workflow {
  border: 2px dashed var(--v-accent-base) !important;
  overflow-y: hidden;
  border-radius: 0 !important;

}

.ghost-block-answer {
  border: 2px dashed var(--v-accent-base) !important;
  overflow-y: hidden;
  border-radius: 0 !important;
}

.dragAreaEmptyPage, .dragAreEmptyChecklist, .dragAreaEmptyQuiz {
  overflow-y: hidden;
}

.edit-mode .chosen-block {
  margin-top: 0 !important;
}
.video-wrapper,
.scorm-player {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}

.edit-mode .content-block:hover iframe {
  pointer-events: none;
}

.edit-mode .list-group-item {
  position: relative;
  border: 1px solid transparent;
}

.edit-mode .list-group-item:hover {
  border: 1px solid var(--v-accent-base);
}

.edit-mode-survey .list-group-item:hover {
  border-radius: 24px 0 24px 24px;
}

.edit-mode .list-group-item:hover .v-toolbar {
  position: absolute;
  right: 0;
  display: block !important;
  z-index: 1;
}

.edit-mode .list-group-item:hover .v-toolbar .v-icon:focus::after {
  opacity: 0 !important;
}

.edit-mode .list-group-item:hover .moveup-icon {
  position: absolute;
  left: 50%;
  margin-left: -15px;
  display: block !important;
  top: 0;
  background: white;
  border: 1px solid var(--v-accent-base);
  border-top: 0;
  padding: 0 4px;
  z-index: 1;
}
.edit-mode .list-group-item:hover .moveup-icon.v-icon:focus::after {
  opacity: 0 !important;
}

.edit-mode .list-group-item:hover .movedown-icon {
  position: absolute;
  left: 50%;
  margin-left: -15px;
  display: block !important;
  bottom: 0;
  background: white;
  border: 1px solid var(--v-accent-base);
  border-bottom: 0;
  padding: 0 4px;
  z-index: 1;
}
.edit-mode .list-group-item:hover .movedown-icon.v-icon:focus::after {
  opacity: 0 !important;
}
.edit-mode .list-group-item .v-toolbar .v-toolbar__content {
  display: block;
  padding: 0;
  border-left: 1px solid var(--v-accent-base);
  border-bottom: 1px solid var(--v-accent-base);
  border-right: 1px solid var(--v-accent-base);
  margin-right: -1px;
}
.edit-mode-checklist, .edit-mode-page {
  padding-bottom: 100px;
}

.edit-mode-checklist,
.view-checklist {
  overflow-x: hidden;
}
.edit-mode-checklist .video-wrapper,
.view-checklist .video-wrapper {
  margin-top: 8px;
}
.edit-mode-checklist .custom-image,
.view-checklist .custom-image {
  margin-top: 8px;
}
.edit-mode-checklist .theme--light.v-input input {
  color: var(--v-darktext-base) !important;
  font-weight: bold;
}

.checklist-off-icon .v-icon {
  font-size: 36px;
}

.no-hover::before {
  display: none;
}

.col.hover {
  cursor: pointer;
}

.video-wrapper iframe,
.video-wrapper object,
.video-wrapper embed,
.scorm-player iframe,
.scorm-player object,
.scorm-player embed {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.embedded-code-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.embedded-code-wrapper iframe {
  aspect-ratio: 16 / 9;
  max-width: 100%;
}

.embedded-code-wrapper .default-code {
  background-image:url('./assets/editor_images/iframe_grey.jpg');
  background-size: cover;
}

/*.chosen {
  height: 100px;
  overflow-y: hidden;
  border-radius: 5px;
  background-color: red;
  border: 2px dashed  var(--v-accent-base);
  opacity: 0.1;
}
.drag {
  height: 100px;
  overflow-y: hidden;
  border-radius: 5px;
}*/

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).publish-scorm {
  background-color: var(--v-greytextlight-base) !important;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).publish-scorm {
  color: #ffffff !important;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).cancel {
  background-color: var(--v-darktext-base) !important;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).create-template {
  background-color: var(--v-accent-base) !important;
}

.stats-loader-mobile {
  position: fixed;
  left: 50%;
  margin-left: -35px;
}
.theme--light
  .edit-page
  .v-expansion-panels
  .v-expansion-panel:not(:first-child)::after {
  transform: rotate(90deg);
  width: 100px;
  z-index: -999;
  margin: 0 auto;
  border-color: var(--v-accent-base);
  border-width: 4px;
}

.v-expansion-panel--active:not(:first-child)::after,
.v-expansion-panel--active + .v-expansion-panel::after {
  opacity: unset;
}

.workflow-breadcrumbs {
  margin-left: -10%;
}
.workflow-breadcrumbs-mobile {
  margin-left: 68px;
}
.theme--light
  .workflow
  .v-expansion-panels
  .v-expansion-panel:not(:first-child)::after {
  transform: rotate(90deg);
  width: 34px;
  z-index: -999;
  margin: 0 auto;
  border-color: var(--v-primary-base);
  border-width: 2px;
}

.workflow .v-expansion-panel--active:not(:first-child)::after,
.workflow .v-expansion-panel--active + .v-expansion-panel::after {
  opacity: unset;
  margin-top: 0px;
}

.workflow-overview .workflow-action {
  position: relative;
}
.workflow-overview .workflow-action::before {
  transform: rotate(90deg);
  width: 34px;
  z-index: -999;
  margin: 0 auto;
  content: '';
  border: 1px solid var(--v-greytextlight-base);
  display: block;
}

.workflow-overview .workflow-action .broken-action {
  border: 2px solid var(--v-error-base);
}
.workflow-overview .workflow-action .broken-icon {
  position: absolute;
  left: -50px;
  top: 50%;
  transform: translateY(-50%);
}

.workflow .workflow-action .broken-card {
  border: 2px solid var(--v-error-base);
  margin-top: -5px;
  z-index: 1;
}

.workflow-action .v-text-field.v-input--is-focused .v-input__slot {
  border: none !important;
}

.workflow-action-users {
  position: absolute;
  right: -40px;
  top: 30px;
}

.delay-action-time label{
  overflow: visible !important;
}

.custom-border {
  border: 2px dashed var(--v-primary-base);
}

.select-items .v-select__selection {
  padding: 0 8px;
}

.select-items.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-bottom: 0;
}
.editor-text-area-template .ProseMirror,
.editor-email-template .ProseMirror{
  min-height: 200px;
  max-height: 600px;
  overflow-y: auto;
}

.editor-text-area-template .ProseMirror p,
.editor-email-template .ProseMirror p{
  margin: 0;
}

.editor-text-area-template p.is-empty:first-child::before{
  color: var(--v-greytext-base);
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}

/* EDITOR */
.ProseMirror:focus {
  outline: none;
}

.ProseMirror .add-transparent-border {
  border: 2px dashed transparent;
}

.ProseMirror .has-focus {
  border: 2px dashed var(--v-bluelight-base);
}

.ProseMirror .emoji.has-focus {
  border: none;
}

.document .ProseMirror {
  border: 2px dashed transparent;
}

.document .ProseMirror-focused {
  border: 2px dashed var(--v-bluelight-base);
  margin: -12px -20px;
  border-radius: 24px;
  padding: 12px 20px;
}

.document .ProseMirror-focused .has-focus {
  border: 2px dashed transparent;
}

.custom-image-banner.large {
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.custom-image-banner.medium {
  width: 85%;
  height: auto;
  margin: 0 auto;
}
.custom-image-banner.small {
  width: 70%;
  height: auto;
  margin: 0 auto;
}
.custom-image.large {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: auto;
}
.custom-image.medium {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 85%;
  height: auto;
}
.custom-image.small {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  height: auto;
}

.image-size input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.image-size input::-webkit-outer-spin-button,
.image-size input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.custom-file-doc-title {
  width: 63%;
}
.custom-file-doc-position {
  vertical-align: top;
}

.content-block {
  max-width: 960px;
  margin: 0 auto;
}

.white-background .content-block:last-child {
  margin-bottom: 40px;
}

.content-block p {
  margin: 0;
}

.activity-page-container h1 {
  font-size: 96px;
}
.activity-page-container-mobile h1 {
  font-size: 58px;
}
.activity-page-container h2 {
  font-size: 60px;
}
.activity-page-container-mobile h2 {
  font-size: 36px;
}
.activity-page-container h3 {
  font-size: 48px;
}
.activity-page-container-mobile h3 {
  font-size: 28px;
}
.activity-page-container h4 {
  font-size: 34px;
}
.activity-page-container-mobile h4 {
  font-size: 20px;
}
.activity-page-container h5 {
  font-size: 24px;
}
.activity-page-container-mobile h5 {
  font-size: 16px;
  line-height: 1.2em;
}
.activity-page-container h6 {
  font-size: 20px;
}
.activity-page-container-mobile h6 {
  font-size: 14px;
}
.activity-page-container p {
  font-size: 16px;
}
.activity-page-container-mobile p {
  font-size: 14px;
}
.activity-page-container p.small {
  font-size: 14px;
}
.activity-page-container-mobile p.small {
  font-size: 12px;
}

.activity-page-container a,
.activity-page-container-mobile a {
  text-decoration: none;
}

p.small {
  font-size: 14px;
}

.custom-draft-tag {
  position: absolute;
  top: 13px;
  z-index: 1;
}
.custom-draft-tag-style-more-right {
  right: 94px;
}
.custom-draft-tag-style-less-right {
  right: 10px;
}

/*navigation forum*/
.edit-activity.button-responsive {
  right: 415px;
}
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  box-shadow: none !important;
}

.page-block.v-card--link:before,
.question-block.v-card--link:before {
  background: none;
}

/** v-bottom-navigation class **/
.v-item-group.v-bottom-navigation {
  bottom: 0;
  display: flex;
  left: 0;
  justify-content: center;
  width: 100%;
  box-shadow: 0px 2px 4px -1px rgba(38, 50, 56, 0.1),
    0px 4px 5px 0px rgba(38, 50, 56, 0.1),
    0px 1px 10px 0px rgba(38, 50, 56, 0.1);
}
.v-item-group.v-bottom-navigation
  .v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: transparent;
}
.v-item-group.v-bottom-navigation .v-btn {
  border-radius: 0;
  box-shadow: none;
  flex: 0 1 auto;
  font-size: 0.75rem;
  height: inherit;
  max-width: 168px;
  min-width: 80px;
  position: relative;
  text-transform: none;
}
.v-item-group.v-bottom-navigation .v-btn:after {
  content: none;
}
.v-item-group.v-bottom-navigation .v-btn .v-btn__content {
  flex-direction: column-reverse;
  height: inherit;
}
.v-item-group.v-bottom-navigation .v-btn .v-btn__content > *:not(.v-icon) {
  line-height: 1.2;
}
.v-item-group.v-bottom-navigation .v-btn.v-btn--active {
  color: inherit;
}
.v-item-group.v-bottom-navigation .v-btn.v-btn--active:not(:hover):before {
  opacity: 0;
}
/** end v-bottom-navigation class **/

.content-create-template-dialog .v-card .v-toolbar .v-toolbar__content {
  padding: 0;
}

.content-create-template-dialog .v-tab {
  text-transform: none !important;
}

.trial-absolute-button {
  margin-top: 88px;
}

.trial-absolute-button-md {
  margin-top: 100px;
}
.trial-hub-absolute-button {
  margin-top: 0px;
}

.trial-hub-absolute-button-md {
  margin-top: 0px;
}

.upgrade-card-action {
  background-color: var(--v-accent-base);
  height: 70px;
  color: white;
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
}

.subscription-card-action {
  background-color: var(--v-background-base);
  height: 70px;
  color: black;
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
}

.base-background {
  background-color: var(--v-background-base) !important;
}

@media screen and (max-width: 1024px) {
  .mail-name {
    min-width: unset;
    max-width: unset;
  }

  a.exit-btn.v-btn:not(.v-btn--round).v-size--default {
    padding-right: 0;
  }

  h3.pl-6.text-truncate {
    padding-left: 10px !important;
  }
}

@media screen and (max-width: 470px) {
  .mail-name {
    min-width: 200px;
    max-width: 230px;
  }
}

@media screen and (max-width: 370px) {
  .mail-name {
    min-width: 145px;
    max-width: 230px;
  }
}
@media screen and (max-width: 300px) {
  .mail-name {
    min-width: 105px;
    max-width: 230px;
  }
}

p:empty::after {
  content: "\00A0";
}

.disable-events {
  pointer-events: none;
}

.theme--light.v-btn.v-btn--disabled,
.theme--light.v-btn.v-btn--disabled .v-icon {
  color: var(--v-disabled-base) !important;
}

.theme--light.v-btn.v-btn--disabled .v-btn__content, 
.theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon,
.theme--light.v-btn.v-btn--disabled .v-btn__loader{
  color: white !important;
}
.theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon.accent--text{
  color: var(--v-accent-base) !important;
}

.audio-wrapper {
  background-color: inherit !important;
}
.audio-wrapper .theme--light.v-btn.v-btn--disabled .v-btn__content,
.audio-wrapper .theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon{
  color: var(--v-disabled-base) !important;
} 

.v-picker .theme--light.v-btn.v-btn--disabled .v-btn__content,
.v-picker.theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon{
  color: var(--v-disabled-base) !important;
} 

.disabled-button-free {
  width: 94px !important;
}

.pro-chip {
  position: absolute;
  top: 0;
  right: 0;
}

.pro-chip-fab-button {
  position: absolute;
  top: -15px;
  right: -10px;
}

/** colored radio options */
.colored-options .option {
  border: 1px solid var(--v-greytext-base);
}
.colored-options .option.selected {
  border: 1px solid var(--v-accent-base);
}

.colored-options .option .v-input--selection-controls__input {
  margin-bottom: 20px;
}

.colored-options.forum .option .v-input--selection-controls__input {
  margin-bottom: 0;
}

.permissions.colored-options .v-input {
  border-radius: 16px;
  border: 1px solid var(--v-greytext-base);
}
.permissions.colored-options .v-input.accent--text{
  border: 1px solid var(--v-accent-base);
}

/* .colored-options .v-input--checkbox .v-input--selection-controls__input {
  margin-bottom: 20px;
}  */
.option.v-radio--is-disabled .option-slot-pro{
  opacity: 30%;
}
.colored-options .option.v-radio--is-disabled{
  /** grey text with opacity */
  border: 1px solid rgba(124, 131, 134, 0.3);
}

.option.v-radio--is-disabled .v-icon{
  opacity: 30%;
}

.subscription-period-switch {
  width: fit-content !important;
  flex-grow: unset !important;
}

.subscription-period-switch .v-input--switch__track {
    color: var(--v-greytextlight-base) !important;
}

.subscription-period-switch .v-input--switch__track.primary--text {
    color: var(--v-greytextlight-base) !important;

}

.subscription-period-switch .v-input--switch__thumb {
  color: var(--v-accent-base) !important;
}

.subscription-period-switch .v-input--switch__thumb.primary--text {
  color: var(--v-accent-base) !important;
}

.preview-content{
  width: calc(100% - 276px) !important;
}

.card-padding {
  padding: 120px;
}

.emoji-picker {
  width: 100% !important;
  background: white !important;
}
.emoji-picker .category svg{
  max-height: 14px;
  max-width: 14px;
}

.emoji-picker .category.active{
  border-bottom: 3px solid var(--v-accent-base) !important;
}

.emoji {
  font-family: "Twemoji Country Flags","Segoe UI Emoji" !important;
}

.emoji img{
  height: 24px;
  width: auto;
}

.connected-hubs-empty-list {
  height: 150px;
}

.hub-edit-card .v-radio--is-disabled {
  opacity: 30%;
}
/* search-people */
.v-autocomplete.v-select.v-input--is-focused input{
  min-width: 0px !important;
}



/* notifications */
.mark-read {
  font-size: 11px !important;
}
.notification {
  font-size: 12px !important;
}
.notification.unread {
  background-color: var(--v-bluelightBackground-base);
}
.notification .v-list-item__subtitle {
  font-size: 12px !important;
}
.notification .v-list-item__subtitle span.date {
  font-size: 9px !important;
}
.v-badge--dot .error.v-badge__badge{
  border-radius: 7.5px !important;
}
.v-btn--rounded:hover .v-badge--dot .error.v-badge__badge:after{
border-color: #E9EAEA !important;
}
.v-btn--rounded:focus .v-badge--dot .error.v-badge__badge:after{
border-color: #C7CACB !important;
}
.v-badge--dot .error.v-badge__badge::after{
border-color: #fafafa !important;
} 

/* set rule */
.set-rule .theme--light.v-expansion-panels .v-expansion-panel {
  margin: 0;
}

.set-rule .theme--light.v-expansion-panels .v-expansion-panel::before {
  box-shadow: none;
}

.set-rule .theme--light.v-expansion-panels .v-expansion-panel::after {
  border: none !important;
}

.set-rule .theme--light.v-expansion-panels .v-expansion-panel button {
  width: auto;
  min-height: 32px !important;
}

/*planday*/
.planday-user-credentials-checkbox .v-messages {
  color: var(--v-error-base);
  margin-left: 26px;
  margin-top: -8px;
}

.planday-auto-sync-checkbox .v-messages {
  margin-left: 26px;
  margin-top: -8px;
}

/* eduadmin */
.eduadmin-share-sessions .v-messages {
  margin-left: 26px;
  margin-top: -8px;
}

/*survey*/
/*.survey-image-editor {
  aspect-ratio : 1 / 1;
  width:100%;
}*/
.row-pointer:hover {
    cursor: pointer;
}

.survey-answer-image-editor .custom-image.large{
  object-fit: contain;
  object-position: center;
  height: 247px;
}

.survey-question-image-editor .custom-image.large{
  object-fit: contain;
  object-position: center;
  height: 300px;
}

.survey-answer, .survey-answer-card{
  cursor: pointer;
}

.survey-answer-image .v-input__slot{
  padding: 0 !important;
}

.survey-answer-image fieldset{
  border: none !important;
  padding: 0 !important;
}

.survey-answer.v-input--hide-details > .v-input__control > .v-input__slot{
  margin-top: 4px;
  margin-bottom: 4px;
}

.survey-answer textarea {
  font-size: 0.875rem !important;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em !important;
}

.survey-answer-progress .v-input__append-outer{
  align-self: center !important;
}

.survey-answer-progress .v-input__append-outer div{
  width: 40px !important;
  color: var(--v-darktext-base) !important;
}

.survey-rating {
  white-space: break-spaces !important;
}

.survey-open-textarea .v-input__slot, .survey-rating-textarea .v-input__slot{
  background: #ffffff !important;
}

.survey-user .v-input__slot {
  background-color: #ffffff !important;
}

.survey-carousel {
  background-color: var(--v-greyactivitybackground-base);
}

.survey-carousel .v-carousel__item {
  overflow-y: auto !important;
}

.view-survey .selected .v-input__slot, .view-survey .selected.v-card{
  border: 1px solid var(--v-accent-base);
}
.view-survey .not-selected .v-input__slot, .view-survey .not-selected.v-card, .view-survey .v-card .v-input__slot{
  border: 1px solid transparent;
}


.mobile-view .survey-carousel {
  background-color: var(--v-greyactivitybackground-base);
  z-index: 1;
}


.mobile-view .survey-carousel .list-group-item .content-block {
  height: 100%;
}

.mobile-view-simulator {
  height: 520px;
  overflow-y: auto;
}

.mobile-view-simulator.scorm-player{
  height: 520px !important;
}

.mobile-view-simulator-quiz, .mobile-view-simulator-survey {
  height: 452px;
  overflow-y: auto;
}

.mobile-view-scroll-inside {
  background: #ffffff;
}


.border-top-simulator-footer {
  border-top: 1px solid #dddddd;
}

.survey-carousel-navigation {
  background-color: var(--v-greyactivitybackground-base);
}

.rating-filled::before{
  border: 1px solid var(--v-accent-base);
  border-radius: 8px;
  background-color: var(--v-bluelightBackground-base);

}

.rating-notfilled::before{
  border: 1px solid var(--v-greytext-base);
  border-radius: 8px;
}

.survey-ok-button.v-btn--outlined {
  border: thin solid var(--v-accent-base);
}

.survey-start-screen .v-text-field--placeholder .v-text-field__slot input, .survey-end-screen .v-text-field--placeholder .v-text-field__slot input {
  text-align: center;
}

.survey-tabs {
  background-color: var(--v-greyactivitybackground-base) !important;

}

.text-divider {
  background-color: var(--v-greytextlight-base);
}

.theme--light.v-breadcrumbs .v-breadcrumbs__divider, .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled{
  color: var(--v-disabled-base) !important;
}

.pre-wrap {
  white-space: pre-wrap;
}

.alert-absolute {
  position: absolute;
  z-index: 999;
  background-color: white !important;
  right: 12px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn .v-icon{
  color: var(--v-darktext-base) !important;
}

.design-card .v-input--hide-details > .v-input__control > .v-input__slot{
  margin-bottom: 0 !important;
}

.design-card .v-btn-toggle > .v-btn.v-btn{
  padding: 16px 12px !important;
}

/** feed item responsive view */
.desktop-view {
  max-width: 960px;
}

.mobile-view {
  max-width: 375px;
}

.mobile-view.view-page .col-sm-6, .mobile-view.view-page .col-sm-4, .mobile-view.view-page .col-lg-3{
  flex: 0 0 100%;
  max-width: 100%;
}

.mobile-view.view-page .col-lg-3{
  flex: 0 0 50%;
  max-width: 50%;
}

.mobile-view.view-quiz .col-lg-4, .mobile-view.view-quiz .col-md-4{
  flex: 0 0 50%;
  max-width: 50%;
}

.mobile-view.view-quiz .mx-sm-8 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.mobile-view.view-survey .col-sm-6, .mobile-view.view-survey .col-sm-4, .mobile-view.view-survey .col-lg-3, .mobile-view.view-survey .col-6, .mobile-view.view-survey .col-lg-4, .mobile-view.view-survey .col-sm-7{
  flex: 0 0 100%;
  max-width: 100%;
}

/* styling checkboxes */
.checkbox-align-start .v-input--selection-controls__input {
  align-self: start;
}

.radio-align-start .v-input--selection-controls__input {
  align-self: start;
}

/* fix after Vuetify update */
.row {
  margin-top: 0;
  margin-bottom: 0;
}

.row + .row {
  margin-top: 0;
}

.v-tabs-items {
  background-color: transparent !important;
}

.global-search-highlight {
  background-color: #d2efff !important;
}

.quiz-start-image-edit {
  width: 100%;
  object-fit: contain;
  object-position: center;
  height: 252px;
}

.quiz-start-image-view {
  width: 100%;
  object-fit: contain;
  object-position: center;
  height: 252px;
}

/*currency*/
.currency-select {
  width: 70px;
}
.currency-select.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.currency-select .v-input__slot {
  padding-top: 8px !important;
}

.currency-select .v-select__selections input {
  display: none !important;
}

.currency-select .v-input__append-inner {
  width: 0 !important;
}

.currency-select .v-input__icon i{
  margin-left: -24px;
}
.v-text-field.v-input--is-focused .v-input__slot .currency-select .v-input__slot {
  border: none !important;
}

.v-text-field.currency-select.v-input--is-focused .v-input__slot{
  border: none !important;
}

.number-field-no-arrows input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.number-field-no-arrows input::-webkit-outer-spin-button,
.number-field-no-arrows input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.product-cover-image {
  padding-top: 4px !important;
  padding-left: 24px;
}
.product-cover-image .v-input__prepend-outer{
  display: none !important;
}

.product-cover-image .v-input__control .v-input__slot{
  display: none !important;
}
/*tax*/
.tax-select {
  border-radius: 32px;
}

.tax-select .v-select__slot{
  padding: 15px !important;
}
</style>
